// reducers.ts
import { SET_PURCHASE_INFO, SET_STORENO_INFO, ActionTypes } from './actions';

export interface PurchaseInfoState {
  purchaseInfo: any;
  storeNo?: any;
}

const initialState: PurchaseInfoState = {
  purchaseInfo: null,
};

const purchaseInfoReducer = (state: PurchaseInfoState = initialState, action: ActionTypes): PurchaseInfoState => {
  switch (action.type) {
    case SET_PURCHASE_INFO:
      return {
        ...state,
        purchaseInfo: action.payload,
      };
    case SET_STORENO_INFO:
      return {
        ...state,
        storeNo: action.payload,
      };
    default:
      return state;
  }
};

export default purchaseInfoReducer;
